var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustrySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.833,
    height: 30.479,
    viewBox: "0 0 34.833 30.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#71b6f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.324,40.966l-9.465,6.023V42.343a1.634,1.634,0,0,0-2.509-1.378l-9.465,6.023V33.633A1.633,1.633,0,0,0,9.253,32H1.633A1.633,1.633,0,0,0,0,33.633V60.846a1.633,1.633,0,0,0,1.633,1.633H33.2a1.633,1.633,0,0,0,1.633-1.633v-18.5A1.634,1.634,0,0,0,32.324,40.966Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrySolid);
export default __webpack_public_path__ + "static/media/industry-solid.16374f12d0e4160cc59caf576b4d398e.svg";
export { ForwardRef as ReactComponent };